import './appearance.css';
import PhotoInput from '../../components/PhotoInput';
import { useUI } from '../../UIContext';
import { useCallback, useEffect, useState } from 'react';
import { getBlob, post, remove } from '../../services/api';
import { handleErr } from '../../utils/functions';
import { Theme, SUPPORTED_BACKGROUND_IMAGE_THEMES, getThemeLabelPt } from '../../constants/theme';

const themes = SUPPORTED_BACKGROUND_IMAGE_THEMES;

function Appearance() {
    const { setBackgroundImg, setLoading, setMessage, effectiveTheme } = useUI();

    const [themeImages, setThemeImages] = useState({
        [Theme.LIGHT]: undefined,
        [Theme.DARK]: undefined
    });



    const loadThemeImage = useCallback(async (theme) => {
        await getBlob('config/background-image', true, setMessage,
            (response) => {
                setThemeImages((prev) => ({ ...prev, [theme]: response.data }));

                if (theme === effectiveTheme) {
                    setBackgroundImg(response.data);
                }
            },
            (err) => {
                handleErr(setMessage, `Não foi possível recuperar a imagem do site: ${err}`);
            },
            () => {},
            { theme },
            () => {
                setThemeImages((prev) => ({ ...prev, [theme]: undefined }));

                if (theme === effectiveTheme) {
                    setBackgroundImg(undefined);
                }
            }
        );
    }, [effectiveTheme, setBackgroundImg, setMessage]);

    useEffect(() => {
        async function loadAllThemeImages() {
            setLoading(true);
            await Promise.all(themes.map((theme) => loadThemeImage(theme)));
            setLoading(false);
        }

        loadAllThemeImages();
    }, [loadThemeImage, setLoading]);

    async function addImage(theme) {
        const image = themeImages[theme];

        setLoading(true);

        const formData = new FormData();
        formData.append('image', image);
        formData.append('theme', theme);

        await post('config/background-image', formData, true, setMessage,
            () => { 
                setMessage({ type: 'success', text: `A imagem do tema ${getThemeLabelPt(theme)} foi atualizada` });
                setThemeImages((prev) => ({ ...prev, [theme]: image }));

                if (theme === effectiveTheme) {
                    setBackgroundImg(image);
                }
            },
            (err) => {
                handleErr(setMessage, `Não foi possível atualizar a imagem do site: ${err}`);
            },
            () => {
                setLoading(false);
            }
        );
    }

    async function removeImage(theme) {
        setLoading(true);

        const formData = new FormData();
        formData.append('theme', theme);

        await remove('/config/background-image', true, setMessage,
            () => {
                setMessage({ type: 'success', text: `A imagem do tema ${getThemeLabelPt(theme)} foi removida` });
                setThemeImages((prev) => ({ ...prev, [theme]: undefined }));

                if (theme === effectiveTheme) {
                    setBackgroundImg(undefined);
                }
            },
            (err) => {
                handleErr(setMessage, `Não fo possível remover a imagem do site: ${err}`);
            },
            () => {
                setLoading(false);
            },
            formData
        )
    }

    async function onClickSave(e, theme) {
        e.preventDefault();

        if (!!themeImages[theme])
            await addImage(theme);
        else
            await removeImage(theme);
    }

    function onRemovePhoto(theme) {
        setThemeImages((prev) => ({ ...prev, [theme]: undefined }));
    }

    function onChangePhoto(theme, file) {
        setThemeImages((prev) => ({ ...prev, [theme]: file }));

        if (theme === effectiveTheme) {
            setBackgroundImg(file);
        }
    }

    return (
        <div className='appearance-page'>
            <header className='appearance-header'>
                <h1>Aparência</h1>
            </header>

            <form className='appearance-form'>
                <div className='appearance-grid'>
                    <section className='appearance-card'>
                        <div className='appearance-card-header'>
                            <h2>Tema claro</h2>
                        </div>

                        <div className='appearance-photo-wrapper'>
                            <PhotoInput
                                photo={themeImages[Theme.LIGHT]}
                                onChange={(file) => onChangePhoto(Theme.LIGHT, file)}
                                onRemove={() => onRemovePhoto(Theme.LIGHT)}
                                width={'640px'}
                                height={'360px'}
                            />
                        </div>

                        <div className='appearance-card-footer'>
                            <button
                                type='submit'
                                onClick={(e) => onClickSave(e, Theme.LIGHT)}
                                className='blue-button zoom-effect'>
                                Salvar tema claro
                            </button>
                        </div>
                    </section>

                    <section className='appearance-card appearance-card-dark'>
                        <div className='appearance-card-header'>
                            <h2>Tema escuro</h2>
                        </div>

                        <div className='appearance-photo-wrapper'>
                            <PhotoInput
                                photo={themeImages[Theme.DARK]}
                                onChange={(file) => onChangePhoto(Theme.DARK, file)}
                                onRemove={() => onRemovePhoto(Theme.DARK)}
                                width={'640px'}
                                height={'360px'}
                            />
                        </div>

                        <div className='appearance-card-footer'>
                            <button
                                type='submit'
                                onClick={(e) => onClickSave(e, Theme.DARK)}
                                className='blue-button zoom-effect'>
                                Salvar tema escuro
                            </button>
                        </div>
                    </section>
                </div>
            </form>
        </div>
    );
}

export default Appearance;